import type { EventGuestAttendingWith, Paging } from "@anggunpraya-templates/types";

/**
 * Mapping teks tampilan untuk nilai `attending_with`.
 *
 * Dipakai lintas template agar format penyebutan guest tetap konsisten.
 */
export const EVENT_GUEST_ATTENDING_WITH_OBJECT: Record<EventGuestAttendingWith, string> = {
  family: "Keluarga",
  alone: "Sendiri",
  partner: "Partner",
};

/**
 * Nilai paging awal yang dipakai sebagai baseline feed dengan pagination.
 */
export const PAGING: Paging = {
  page: 1,
  limit: 20,
  count: 0,
  total: 0,
  next: false,
  prev: false,
};
